<form [formGroup]="assignmentForm" (ngSubmit)="onSubmit()" class="p-4">
  <!-- Assignment Configuration -->
  <div class="card">
    <div class="card-body">
      <h6 class="card-title text-primary mb-3">Assignment Configuration</h6>

      <!-- Basic Configuration -->
      <div class="row g-3 mb-4">
        <div class="col-md-6">
          <label for="type" class="form-label">Assignment Type</label>
          <select id="type" formControlName="type" class="form-select">
            <option value="FIXED">Fixed Office</option>
            <option value="LOCATION_BASED">Location Based</option>
            <option value="MULTIPLE_LOCATION">Multiple Location Options</option>
          </select>
        </div>

        <div class="col-md-6">
          <label for="officeLevel" class="form-label">Office Level</label>
          <select
            id="officeLevel"
            formControlName="officeLevel"
            class="form-select">
            <option *ngFor="let level of officeLevels" [value]="level">
              {{ level }}
            </option>
          </select>
        </div>
      </div>

      <!-- Type-specific Configuration -->
      <div class="configuration-details">
        <!-- Fixed Office -->
        <div *ngIf="assignmentForm.get('type')?.value === 'FIXED'" class="mb-3">
          <label for="officeId" class="form-label">Select Office</label>
          <ng-select
            [items]="availableOffices"
            [loading]="isLoadingOffices"
            bindLabel="name"
            bindValue="id"
            [clearable]="false"
            placeholder="Select an office"
            formControlName="officeId"
            appendTo="body">
            <ng-template ng-option-tmp let-item="item">
              <div class="d-flex flex-column">
                <span>{{ item.name }}</span>
                <small class="text-muted"
                  >{{ item.code }} - {{ item.email }}</small
                >
              </div>
            </ng-template>
            <ng-template ng-loadingtext-tmp>
              <span
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"></span>
              Loading offices...
            </ng-template>
          </ng-select>
          <small
            class="text-muted mt-1 d-block"
            *ngIf="availableOffices.length === 0 && !isLoadingOffices">
            No offices found for the selected level
          </small>
        </div>

        <!-- Location Based -->
        <div
          *ngIf="assignmentForm.get('type')?.value === 'LOCATION_BASED'"
          class="mb-3">
          <label for="formFieldKey" class="form-label">Form Field Key</label>
          <input
            type="text"
            id="formFieldKey"
            formControlName="formFieldKey"
            class="form-control"
            placeholder="Enter form field key" />
        </div>

        <!-- Multiple Location -->
        <div
          *ngIf="assignmentForm.get('type')?.value === 'MULTIPLE_LOCATION'"
          class="mb-3">
          <label class="form-label">Form Field Keys</label>
          <div formArrayName="formFieldKeys" class="field-keys-container">
            <div
              *ngFor="let key of formFieldKeysArray.controls; let i = index"
              class="d-flex gap-2 mb-2">
              <input
                [formControlName]="i"
                type="text"
                class="form-control"
                placeholder="Enter field key" />
              <button
                type="button"
                (click)="removeFormFieldKey(i)"
                class="btn btn-outline-danger">
                <i class="fas fa-times"></i>
              </button>
            </div>

            <button
              type="button"
              (click)="addFormFieldKey()"
              class="btn btn-outline-primary btn-sm mt-2">
              <i class="fas fa-plus me-1"></i> Add Field Key
            </button>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn btn-outline-dark" (click)="onCancel()">
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="!assignmentForm.valid || isLoadingOffices"
          class="btn btn-primary">
          <span
            *ngIf="isLoadingOffices"
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"></span>
          Save Assignment
        </button>
      </div>
    </div>
  </div>
</form>
